<template>
  <div class="bonuses p-24-32">
    <div class="box">
      <div class="title-b">{{$t('referral_system_2')}}</div>
      <!-- <div class="item">
        <span>Бонусы SLT </span> <span>{{ bonus }} SLT</span>
      </div>
      <div class="item">
        <span>Количество рефералов первого уровня</span>
        <span>{{ ref_count_1 }}</span>
      </div>
      <div class="item">
        <span>Количество рефералов второго уровня</span>
        <span>{{ ref_count_2 }}</span>
      </div>
      <div class="item">
        <span>Мой реферальный код</span>
        <input type="hidden" :value="ref_code" id="ref-code" /><span
          >{{ ref_code }}
          <button class="copy" @click="copyRefCode">
            <img src="@/assets/img/icon/copy.svg" alt="" /></button
        ></span>
      </div> -->
      <div class="item">
        <span>{{$t('referral')}}</span>
        <span class="ref_code" v-if="referal">{{ referal }}</span>
        <span v-else class="ref_code"
          >{{$t('specify')}}
          <button
            class="ref-change"
            data-toggle="modal"
            data-target="#change-ref"
          >
            <img src="@/assets/img/icon/edit.svg" alt="" /></button
        ></span>
      </div>
      <div class="text text2">
        {{$t('text_14')}}
      </div>
      <img src="@/assets/img/bonus.jpg" alt="" class="img" />
      <div class="text" v-html="$t('text_15')">

      </div>
    </div>
    <div class="modal-email">
      <div id="change-ref" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="loader" v-if="loader">
                <img src="@/assets/img/loader.gif" alt="" />
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                <img src="@/assets/img/icon/close.svg" alt="" />
              </button>
              <div class="title-m">{{$t('referral')}}</div>
              <form action="" @submit.prevent="changeRefCode">
                <input
                  type="text"
                  required
                  :placeholder="$t('referral_code')"
                  v-model="referal"
                />
                <button class="button-yellow">{{$t('specify')}}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-email">
      <div id="change-referal" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                <img src="@/assets/img/icon/close.svg" alt="" />
              </button>
              <div class="title-m">{{$t('referral_code_changed')}}</div>
              <button
                class="button-yellow"
                data-dismiss="modal"
                aria-hidden="true"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "referral",
  data() {
    return {
      loader: false,
      bonus: "",
      referal: "",
      ref_count_1: "",
      ref_count_2: "",
      profile: "",
      new_referal: ""
    };
  },
  created() {
    this.profile = JSON.parse(localStorage.getItem("user"));
    this.getRefferal();
    // console.log(localStorage.user)
  },
  methods: {
    copyRefCode() {
      let refCodeToCopy = document.querySelector("#ref-code");
      refCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      refCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
      } catch (err) {
        console.log("Oops, unable to copy");
      }

      /* unselect the range */
      refCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    getRefferal() {
      this.profile = JSON.parse(localStorage.getItem("user"));
      this.bonus = this.profile.bonus;
      this.referal = this.profile.referal;
      this.ref_count_1 = this.profile.referals_count.level_1;
      this.ref_count_2 = this.profile.referals_count.level_2;
    },
    changeRefCode() {
      localStorage.removeItem("user");
      this.loader = true;
      let obj = {};
      obj["referal"] = this.referal;
      this.$axios
        .post("/user/save", obj)
        .then(response => {
          let $response = response.data;
          if ($response.code === 0) {
            this.errors = $response.message;
            console.log("error");
          } else {
            this.profile = $response.data;
            localStorage.setItem("user", JSON.stringify(this.profile));
            // this.profile.referal = obj["referal"];
            // this.$auth.saveToken(
            //   "Basic " + btoa(this.profile.iin + ":" + this.referal)
            // );
            $("#change-ref").modal("hide");
            $("#change-referal").modal("show");
          }
          this.loader = false;
        })
        .catch(e => console.log(e));
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/cabinet/referral.vue